import RAW_DIRECTIVE_DATA from "./directives.yml";
const DIRECTIVE_METADATA = RAW_DIRECTIVE_DATA;
export function directiveEntry(directiveId, mode, baseEntry = {}) {
    const directiveMetadataData = DIRECTIVE_METADATA[directiveId];
    if (directiveMetadataData == undefined) {
        throw Error(`Client logic error, cannot find directive metadata for ${directiveId}`);
    }
    let name = directiveMetadataData.side_panel_name;
    if (name && !(typeof name == "string")) {
        const modeName = name[mode];
        if (modeName == undefined) {
            throw Error(`Client logic error, cannot find directive metadata for ${directiveId}`);
        }
        name = modeName;
    }
    let description = directiveMetadataData.side_panel_description;
    if (description && !(typeof description == "string")) {
        description = description[mode];
    }
    let help = directiveMetadataData.help;
    if (help && !(typeof help == "string")) {
        help = help[mode];
    }
    if (help) {
        help = help.replace(/%MODE%/g, mode);
    }
    const entry = Object.assign({ id: directiveId }, baseEntry);
    if (name) {
        entry.name = name;
    }
    if (description) {
        entry.description = description;
    }
    if (help) {
        entry.help = help;
    }
    return entry;
}
